<!-- 库存分布查询 -->
<template>
   <div class="page_content">
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
         </div>
      </div>

      <div class="page_content_center">
         <el-table 
            :key="tableFlag" 
            stripe 
            :data="tableData" 
            :height="tableHeight" 
            border 
            style="width: 100%" 
            size="mini" 
            :scroll-x="true"
            v-loading="loading"
            element-loading-text="正在加载库存分布数据..."
            element-loading-spinner="el-icon-loading">

            <!-- 序号列 -->
            <el-table-column 
               label="序号" 
               type="index" 
               width="60" 
               align="center">
            </el-table-column>

            <!-- 动态生成表格列 -->
            <el-table-column v-for="(colName, index) in colNameList" :key="index" :prop="`col${index}`" :label="colName" :min-width="getColumnWidth(index)"  align="center"
                             show-overflow-tooltip>
               <template slot-scope="scope">
                  <span v-if="index < 6" class="text-content">
                     {{ scope.row[`col${index}`] || '-' }}
                  </span>
                  <span v-else class="number-content" :class="getStockClass(scope.row[`col${index}`])">
                     {{ formatStock(scope.row[`col${index}`]) }}
                  </span>
               </template>
            </el-table-column>

            <!-- 空数据提示 -->
            <template slot="empty">
               <div class="empty-data">
                  <i class="el-icon-box"></i>
                  <p>暂无库存分布数据</p>
                  <p class="empty-tip">请尝试调整搜索条件或联系管理员</p>
               </div>
            </template>
         </el-table>

         <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber">
            </v-pagination>
         </div>
      </div>

      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
      </el-dialog>

      <customDesign ref="customDesign"></customDesign>
   </div>
</template>
 
<script>
import SearchScheme from "../../../byComponents/SearchScheme.vue"

const searchList = [
   {
      showField: "商品名称",
      entityField: "bgmName",
      isShow: 1,
      fieldType: "string",
      searchId: null,
      formatterContent: null,
      isRift: null,
      riftField: null,
      setField: null,
      fieldWeight: 120,
   },
    {
        showField: "门店名称",
        entityField: "storeName",
        isShow: 1,
        fieldType: "search",
        searchId: 293839281728,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField:  "storeName,storeId",
        fieldWeight: 120,
    },
   
]

export default {
   components: {
      SearchScheme,
   },
   data() {
      return {
         searchList: searchList,
         getRequestData: {
            bgmName: "",
            page: 1,
            rows: 30,
            storeId: "",
            start: "",
            end: "",
            businessId: "",
            storeName: "",
         },
         seTitle: "",
         DialogVisible: false,
         seId: "",
         setField: "",
         setType: "",
         seWidth: "0",
         parentSearchData: {},
         returnData: {
            pages: 0,
            total: 0,
            pageNum: 0,
            list: [],
         },
         buttonList: [],
         tableFlag: 0,
         tableHeight: 0,
         colNameList: [],
         tableData: [],
         rawData: null,
         loading: false,
      }
   },
   computed: {},
   methods: {
      // 获取列宽度
      getColumnWidth(index) {
         if (index === 0) return 200; // 商品名称
         if (index === 1) return 150; // 商品编码
         if (index === 2) return 100; // 包装单位
         if (index === 3) return 150; // 规格
         return 120; // 库存列
      },



      // 格式化库存数字
      formatStock(value) {
         if (value === null || value === undefined || value === '') return '-';
         return value;
      },

      // 获取库存样式类
      getStockClass(value) {
         if (value === null || value === undefined || value === '') return '';
         if (typeof value === 'number') {
            if (value < 0) return 'negative-stock';
            if (value === 0) return 'zero-stock';
            if (value > 0 && value < 10) return 'low-stock';
         }
         return 'normal-stock';
      },

      // 转换数据格式
      convertDataFormat(apiData) {
         if (!apiData || !apiData.colNameList || !apiData.date) {
            return { colNameList: [], tableData: [], total: 0 };
         }

         const colNameList = apiData.colNameList;
         const tableData = apiData.date.map(row => {
            const rowData = {};
            row.forEach((cell, index) => {
               rowData[`col${index}`] = cell;
            });
            return rowData;
         });

         return { 
            colNameList, 
            tableData, 
            total: apiData.total || tableData.length 
         };
      },

      // 检索相关方法
      openSearch(val) {
         this.setType = val.type;
         this.seId = val.sId;
         this.setField = val.sField;
         this.parentSearchData[this.setType] = this.getRequestData[this.setType];
         this.DialogVisible = true;
      },

      paramValue(val) {
         let arr = this.setField.split(',');
         arr.forEach(item => {
            this.getRequestData[item] = val[item];
         });
      },

      changeInputModel(val) {
         if (val) {
            this.paramValue(val);
         }
         this.DialogVisible = false;
      },

      getSeWidth(e) {
         this.seWidth = e + "%";
      },

      getSearchName(e) {
         this.seTitle = e;
      },

      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path);
         this.$refs["customDesign"].openBox(
            pathInfo.jurId,
            {},
            pathInfo.jurName
         );
      },
      // 获取数据列表
      async getPageInfo() {
         await this.getDataList();
      },

      // 动作集合
      async actionSet(actionData) {
         switch (actionData.actionType) {
            case 0: // 查询
               this.getDataList();
               break;
            default:
               break;
         }
      },

      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },

      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },

      // 获取数据列表
      async getDataList() {
         try {
            this.loading = true;
            let responseData = await this.$http.deraBgmTypeBgsDistribute(this.getRequestData);

            if (responseData.status === 200) {
               // 处理返回的数据格式
               const result = this.convertDataFormat(responseData.result);

               this.colNameList = result.colNameList;
               this.tableData = result.tableData;

               // 设置分页信息 - 使用后端返回的total字段
               this.returnData.total = responseData.result.total || result.tableData.length;
               this.returnData.pageNum = this.getRequestData.page;
               this.returnData.pages = Math.ceil(this.returnData.total / this.getRequestData.rows);

               this.$nextTick(() => {
                  this.tableHeight = this.$common.getTableHeight();
                  this.tableFlag++;
               });
            } else {
               this.$message({
                  message: responseData.message || '获取数据失败',
                  type: "error",
               });
            }
         } catch (error) {
            console.error('获取库存分布数据失败:', error);
            this.$message({
               message: '获取数据失败，请稍后重试',
               type: "error",
            });
         } finally {
            this.loading = false;
         }
      },

      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
      },


   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {

      this.getPageInfo();
      this.getButtonList();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      this.$nextTick(() => {
         this.tableHeight = this.$common.getTableHeight();
         this.tableFlag++;
      });
   },
   updated() {
      this.$nextTick(() => {
         this.tableHeight = this.$common.getTableHeight();
      });
   }
}
</script>
<style scoped>
.page_content_center {
   width: 100%;
   overflow-x: auto;
   overflow-y: hidden;
}

/* 文本内容样式 */
.text-content {
   color: #333;
   font-weight: 500;
}

/* 数字内容样式 */
.number-content {
   font-weight: 600;
   text-align: right;
}

/* 库存状态样式 */
.negative-stock {
   color: #f56c6c;
}

.zero-stock {
   color: #909399;
}

.low-stock {
   color: #e6a23c;
}

.normal-stock {
   color: #67c23a;
}

/* 表格样式优化 */
::v-deep .el-table {
   font-size: 12px;
}

::v-deep .el-table th {
   font-weight: 600;
   color: #303133;
}

::v-deep .el-table td {
   padding: 8px 0;
}

::v-deep .el-table .cell {
   padding: 0 8px;
}

/* 固定列阴影 */
::v-deep .el-table__fixed-right {
   box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
}

::v-deep .el-table__fixed {
   box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}

</style>